export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];
export const MIN_PAGINATION_ROWS = Math.min(...PAGE_SIZE_OPTIONS);
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[1];
export const MAX_VISIBLE_PAGES = 5;
export const FIXED_WIDTH_PAGE_COUNT = MAX_VISIBLE_PAGES + 2;
